<template>
  <div class="fpx">
    <div class="nav">
      <p>
        <span :class="{ act: navAct == 0 }" @click="changeNav(0)">Online Banking</span>
        <span :class="{ act: navAct == 1 }" @click="changeNav(1)">Credit / Debit Card</span>
      </p>
      <span v-show="navAct == 0">Pay with FPX (Current and Saving Account)</span>
      <span v-show="navAct == 1">Pay with FPX (Credit Card Account)</span>
    </div>
    <div class="items">
      <el-form :model="fpxForm" :rules="rulesForm" ref="fpxForm" label-width="0" class="fpxForm">
        <el-form-item prop="amount" v-if="!!!$route.query.tradeSerialNo">
          <p>{{pc_lang.Amount}}</p>
          <el-input v-model="fpxForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_amount" size="medium"></el-input>
        </el-form-item>
        <el-form-item prop="bank">
          <p>{{pc_lang.Select_bank_for_transfer}}</p>
          <el-select v-model="fpxForm.bank" :placeholder="pc_lang.Please_select_the_transfer_bank" size="medium">
            <el-option v-for="(val, key) in bankList" :label="val" :value="key" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="email">
          <p>{{pc_lang.Email_address}}</p>
          <el-input v-model="fpxForm.email" prefix-icon="el-icon-message" autocomplete="off" :placeholder="pc_lang.Enter_your_email_address" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <div v-show="0" class="callbackForm" v-html="callbackForm"></div>
      <div class="submit">
        <p>我已阅读并同意 <span><a href="https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp" target="blank">《FPX条款》</a></span></p>
        <el-button type="primary" size="medium" class="nextStep" @click="regForm('fpxForm')">{{pc_lang.Next_step}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as RegExp from '@/utils/RegExp'
import * as API_PAY from '@/api/pay'
import * as API_BANK from '@/api/bank'

export default {
  name: 'FPX',
  props: ['currencyShort'],
  components: {

  },
  data(){

    return {
      navAct: 0,
      // 提交完成
      finish: 0,
      fpxForm: {
        amount: '',
        bank: '',
        email: '',
      },
      bankList: [],
      callbackForm: ''
    }
  },
  computed: {
    rulesForm() {
      // email验证
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_your_email_address));
        } else if (!RegExp.email.test(value)) {
          callback(new Error(this.pc_lang.Enter_your_correct_email_address));
        } else {
          callback();
        }
      };
      // 金额验证
      var validateMoney = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_amount));
        } else if (!RegExp.money.test(value)) {
          callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
        } else {
          callback();
        }
      };
      return {
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ],
        bank: [
          { required: true, message: this.pc_lang.Please_select_the_transfer_bank, trigger: 'change' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  async mounted() {

  },
  created() {
    this.getBank()
  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getPayItem().then(()=>{
            document.querySelector('.callbackForm form').submit()
          })
        }else{
          return false
        }
      })
    },
    /* 获取支付表单 */
    getPayItem() {
      return new Promise((resolve, reject)=> {
        let params = {
          paymentPluginId: 'fpxPayPlugin',
          payMode: 'normal',
          clientType: 'PC',
          sn: this.$route.query.tradeSerialNo || new Date().getTime(),
          tradeType: this.$route.query.tradeSerialNo == undefined ? 'recharge' : 'order',
          amount: this.$route.query.tradeSerialNo == undefined ? this.fpxForm.amount : '',
          email: this.fpxForm.email,
          bankId: this.fpxForm.bank
        }
        API_PAY.getPayQrCode(params.tradeType, params.sn, params).then(res=> {
          this.callbackForm = res.data.gateway_url
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 获取转入转出银行 */
    getBank() {
      let params = {
        currencyShort: this.currencyShort,
        bankType: 'fpx'
      }
      API_BANK.getBankList(params).then(res=> {
        this.bankList = res.data
      },rej=>(console.log(rej)))
    },
    /* 切换nav */
    changeNav(i) {
      if (this.navAct != i) {
        this.navAct = i
        for (let k in this.fpxForm) {
          this.fpxForm[k] = ''
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fpx{
  .nav{
    margin-bottom: 10px;
    p{
      border-bottom: $border;
      margin-bottom: 16px;
      user-select: none;
      span{
        height: 36px;
        padding: 0 12px;
        background: #f2f2f2;
        margin-left: 6px;
        border-radius: 6px 6px 0 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        @extend .transition;
        &:hover, &.act{
          background: darken(#f2f2f2, 10%);
          @extend .transition;
        }
      }
    }
  }
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }
  .submit{
    p{
      padding: 10px 0;
      font-size: 12px;
      span{
        color: #007DD1;
        cursor: pointer;
      }
    }
  }
}
</style>